import React, { useRef, useState } from "react";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image1 from "../../../assets/images/CompanyLogo/person.svg";
import image2 from "../../../assets/icons/arrowleft.svg";
import image3 from "../../../assets/icons/arrowrightblack.svg";
import Testimonials from "../Testimonials";

const testimonials = [
  {
    name: "IT Distribution Business",
    designation: "Chief Financial Officer",
    text: "Our financially stable, fully compliant company faced an inexplicable block on our credit insurance, hindering growth. For years, direct talks with underwriters yielded no results. The TREVEX team meticulously dissected our operations and financials, corrected erroneous information, and successfully negotiated the removal of the block while securing new credit limits. We're grateful and fully recommend TREVEX as a crucial business partner.",
  },
  {
    name: "Commodity Trading Business",
    designation: "Business Manager",
    text: "TREVEX played a crucial role in helping us develop a robust credit policy and successfully navigate the complex trading landscape in the United Arab Emirates. We strongly endorse their services for businesses aiming to strengthen their payment terms and cultivate reliable relationships with both buyers and suppliers.",
  },
];

const TestinomialCaraousel = () => {
  return (
    <div className="max-w-[1178px] mx-auto relative mt-12 sm:mt-12 md:mt-[120px] overflow-hidden">
      <h2 className="text-f24 mt-4 sm:text-[3rem] sm:px-6 md:px-8 font-semibold text-[#012234]">
        What Our Clients Say
      </h2>
      <p className="max-w-[840px] px-[4%] text-f16 md:text-[1rem] px-1.5rem text-[#3C4848] font-normal m-auto">
        Trusted by financial institutions, insurers, and businesses worldwide—see how TREVEX is transforming trade credit.
      </p>
      {/* <ClientSlider /> */}
      <Testimonials />
    </div>
  );
};

const ClientSlider = () => {
  const sliderRef = useRef(null);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(false);

  var settings = {
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 0,
  };
  const handleBeforeChange = (oldIndex, newIndex) => {
    setIsFirstSlide(newIndex === 0);
    setIsLastSlide(newIndex === testimonials.length - 1);
  };

  return (
    <div className="mx-auto md:mt-[48px] md:max-w-[90%] sm:mt-[32px] sm:max-w-full  bg-white">
      <div className="grid grid-cols-5 gap-4 justify-between items-center ">
        <div className="flex justify-center">
          <div
            className={`flex  items-center justify-center rounded-full bg-[#FB512D] w-10 h-10 cursor-pointer ${isFirstSlide ? "cursor-not-allowed bg-white" : ""
              }`}
            onClick={() => !isFirstSlide && sliderRef.current.slickPrev()}
          >
            <img src={image2} alt="Previous" />
          </div>
        </div>
        <div className="col-span-3 ">
          <Slider ref={sliderRef} {...settings} beforeChange={handleBeforeChange}>
            {testimonials.map((testimonial, id) => (
              <div key={id} className="my-auto">
                <div className="text-[#3C4848] flex flex-col items-center">
                  <p className="text-[15px] md:max-w-[820px] mt-[24px] text-normal sm:text-f24 md:text-32 justify-center text-justify md:text-center">{testimonial.text}</p>
                  <div className="flex items-center mt-4">
                    <div>
                      <p style={{ "color": "#e85f3d" }} className="text-f14 md:w-[220px] font-medium text-center">{testimonial.name}</p>
                      <p style={{ "color": "#154366" }} className="text-f12 md:w-[220px] text-center">{testimonial.designation}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className="flex justify-center">
          <div
            className={`flex items-center justify-center rounded-full bg-[#FB512D] w-10 h-10 cursor-pointer ${isLastSlide ? "cursor-not-allowed bg-white" : ""
              }`}
            onClick={() => !isLastSlide && sliderRef.current.slickNext()}
          >
            <img src={image3} alt="Next" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestinomialCaraousel;
